import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setConfig, setPermission, setUser } from "../store/actions";
import Loading from "../component/Loading";

import AuthService from "../service/auth";
import Permission from "../service/permissions";
import Notification from "../component/NotificationsWrapper/Notification";
import PageSuspense from "../component/Common/PageSuspense";
import CommonService from "../service/common";

//Protected Route
//Only allow components access if user is logged in
const PrivateRoute = ({ moduleName, children, lazyLoad = false }) => {
  const user = useSelector((state) => state.user);
  const permissions = useSelector((state) => state.permissions);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUserRef = useRef(user.currentUser);

  useEffect(() => {
    (async () => {
      if (!Array.isArray(permissions)) {
        const getPermissions = async () => {
          const permission = new Permission();
          const { success, data } = await permission.init();

          if (success) dispatch(setPermission(data));
        };

        const getDefaultConfig = async () => {
          const commonService = new CommonService();
          const { success, data } = await commonService.getDefaultConfig();

          if (success) dispatch(setConfig(data));
        };
        await Promise.all([getPermissions(), getDefaultConfig()]);
      }
    })();
  }, [dispatch, permissions]);

  useEffect(() => {
    (async () => {
      if (!currentUserRef.current) {
        setLoading(true);
        const authService = new AuthService();

        const response = await authService.getAuthUser();

        if (response.success) {
          dispatch(setUser(response.data));
          setLoading(false);
        } else navigate("/signin");
      }
    })();

    return () => {};
  }, [dispatch, navigate]);

  if (user.isLoading || loading || !permissions) return <Loading />;

  if (user.currentUser && user.currentUser.is2FARequiredToSet) return <Navigate to="/set2FA" />;

  return user.currentUser && (moduleName === "OPEN" || (permissions && permissions.includes(moduleName))) ? (
    <Notification>{lazyLoad ? <PageSuspense>{children}</PageSuspense> : children}</Notification>
  ) : (
    <Navigate to="/signin" />
  );
};

export default React.memo(PrivateRoute);
